import { useUserInfo } from '../api/hooks/user/useUserInfo'
import { ScoopFallback } from '../components/screens/ScoopFallback/ScoopFallback'
import { ScoopCenter, ScoopCircularProgress } from '../components/ui'

export const AdminRoute = ({ children }) => {
    const { user, loadingUser } = useUserInfo()

    // This prevents rendering sensitive UI before verification
    if (loadingUser) {
        return (
            <ScoopCenter style={{ height: '100vh' }}>
                <ScoopCircularProgress />
            </ScoopCenter>
        )
    }

    // If we have no user data or accountID is not loaded yet, wait
    if (!user || user.accountID === undefined) {
        return (
            <ScoopCenter style={{ height: '100vh' }}>
                <ScoopCircularProgress />
            </ScoopCenter>
        )
    }

    // If NOT admin(accountID !== 'A1'), show "Page Not Found"
    if (user.accountID !== 'A1') {
        return <ScoopFallback notFound />
    }

    // Only render children if IS admin verified
    return <>{children}</>
}
